import React from 'react'
import moment from 'moment'

import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom'
import './DataExports.css'
import { connect } from 'react-redux'
import All from './All'
import DataExport from './DataExport'
import onMount from '../../core/onMount'
import {getDataExports} from './actions'

// const DataExports = () =>
//   <div className="DataExports">
//     <All/>
//   </div>

const mapDispatchToProps = (dispatch) => {
  return {
    // onClick: (token_id)=> dispatch(push(`/account/vehicles/${token_id}`)),
    dispatch
  }
}

const mapStateToProps = (state) => {
  return {
    dataExports: state.models.dataExports,
    isFetchingInitialPoll: state.account.dataExport.isFetchingInitialPoll
  }
}

const MountedAll = onMount(({dispatch}) => dispatch(getDataExports()) )(All)
const ConnectedAll = connect(mapStateToProps, mapDispatchToProps)(MountedAll)

export default ()=>
  <div>
    <Switch>
      <Route exact path={'/account/data-exports'} component={ConnectedAll}/>
      <Route path={'/account/data-exports/new'} component={DataExport}/>
    </Switch>
  </div>



// WEBPACK FOOTER //
// ./src/account/data-export/DataExports.js